import type { PureSettings } from '@/components/base-layouts/defaultSettings';

export interface AppState extends PureSettings {
  lang: string;
  device: 'mobile' | 'desktop' | string;
  transitionName: string;
  multiTab: boolean;
  multiTabFixed: boolean;
}

export const state: AppState = {
  lang: 'zh-CN',
  device: 'desktop',
  // layout: 'side',
  // navTheme: 'light',
  // contentWidth: 'Fluid',
  // fixedHeader: false,
  // fixedSidebar: true,
  // menu: { locale: false },
  // splitMenus: false,
  // title: '标养室智慧运营平台',
  // primaryColor: '#1890ff',
  // colorWeak: false,
  // transitionName: '',
  // multiTab: true,
  // multiTabFixed: false,

  layout: 'mix',
  navTheme: 'light',
  contentWidth: 'Fluid',
  fixedHeader: true,
  fixedSidebar: true,
  menu: { locale: false },
  splitMenus: false,
  title: '标养室智慧运营平台',
  primaryColor: '#1890ff',
  colorWeak: false,
  transitionName: '',
  multiTab: false,
  multiTabFixed: false,
};
